import React, { useEffect } from 'react';

function App() {
  useEffect(() => {
    // Immediate redirect to target domain
    window.location.href = 'https://www.oyunhero.com/';
  }, []);

  // Return null since we don't want to show anything
  return null;
}

export default App;
